import { api } from './postMessage.js';

function handler(payload, e) {
  api.source = e.source;
  api.origin = e.origin;
  api.legacy = true;
  api.sendLocizeIsEnabled();
}
api.addHandler('isLocizeEnabled', handler);
